import React, { useState } from 'react';
import { CoverageDetails } from '@/src/types/availablePlans';
import { Row, Col } from '../../designSystem/Container';
import styles from './DeceaseSection.module.scss';
import { CategoryItems as CategoryItemsType } from '../../types/availablePlans';
import { deceaseSectionTexts } from '@/utils/generalTexts';
import Accordion from '@/designSystem/Accordion';
import Text from '@/designSystem/Text';
import Tooltip from '@/designSystem/Tooltip';
import Icon from '@/designSystem/Icon';
import Alert from '@/designSystem/Alert';

type DeceaseSectionProps = {
  details: CoverageDetails;
};

const DeceaseSection = ({ details }: DeceaseSectionProps) => {
  return (
    <Row justify="center">
      <Col sm={12} md={10} lg={7} className={styles.col_container}>
        <Accordion
          title={deceaseSectionTexts.titleCeiling}
          outline
          titleContainerClass={styles.accordion_container}
        >
          <CeilingTable details={details} />
        </Accordion>
        <Accordion
          title={deceaseSectionTexts.timeCoverage.title}
          outline
          titleContainerClass={styles.accordion_container}
        >
          <UntilDateTable />
        </Accordion>
        <Accordion
          title={deceaseSectionTexts.additionalBeneficiary.title}
          outline
          titleContainerClass={styles.accordion_container}
        >
          <AdditionalBeneficiaryList />
        </Accordion>
        <Accordion
          title={deceaseSectionTexts.exclusions.title}
          outline
          titleContainerClass={styles.accordion_container}
        >
          <Exclusions />
        </Accordion>
      </Col>
    </Row>
  );
};

const CeilingTable = ({ details }: DeceaseSectionProps) => {
  const {
    categories: [category],
  } = details;

  const [showTooltip, setShowTooltip] = useState(false);

  const onOpenTooltipHandler = () => setShowTooltip(true);
  const onCloseTooltipHandler = () => setShowTooltip(false);

  return (
    <div className={styles.container_section}>
      <table className={styles.information_table}>
        <thead>
          <tr>
            <th>{}</th>
            <th>{deceaseSectionTexts.ceiling}</th>
          </tr>
        </thead>
        <tbody>
          {category.items.map((item: CategoryItemsType, idx: number) => (
            <tr key={idx}>
              <td className={styles.left}>
                {item.description === 'Servicios iniciales' ? (
                  <div className={styles.conditional_description}>
                    {item.description}
                    <Tooltip
                      containerClass={styles.tooltip}
                      isShow={showTooltip}
                      onClose={onCloseTooltipHandler}
                      position="top_right"
                      icon={<Icon name="info" onClick={onOpenTooltipHandler} size="medium" />}
                      title=""
                      body={deceaseSectionTexts.tooltip.body}
                    />
                  </div>
                ) : (
                  item.description
                )}
              </td>
              <td className={styles.right}>UF {item.maximum.value?.uf}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const UntilDateTable = () => {
  return (
    <div className={styles.container_section}>
      <Text
        customClass={styles.benefit_paragraph}
        text={deceaseSectionTexts.timeCoverage.description}
      />
      <table className={styles.information_table}>
        <thead>
          <tr>
            <th>{deceaseSectionTexts.timeCoverage.time}</th>
            <th>{deceaseSectionTexts.timeCoverage.coverage}</th>
          </tr>
        </thead>
        <tbody>
          {deceaseSectionTexts.timeCoverage.untilDates.map((dates, idx) => (
            <tr key={idx}>
              <td className={styles.left}>{dates.until}</td>
              <td className={styles.right}>{dates.percentage}%</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Alert
        text={deceaseSectionTexts.timeCoverage.alert.description}
        customClass={styles.coverage_alert}
      />
    </div>
  );
};

const AdditionalBeneficiaryList = () => {
  return (
    <div className={styles.container_section}>
      <Text
        customClass={styles.benefit_paragraph}
        text={deceaseSectionTexts.additionalBeneficiary.description}
      />
      <ul>
        {deceaseSectionTexts.additionalBeneficiary.list.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
};

const Exclusions = () => {
  return (
    <div className={styles.container_section}>
      <Text
        customClass={styles.benefit_paragraph}
        text={deceaseSectionTexts.exclusions.description}
      />
      <ul>
        {deceaseSectionTexts.exclusions.list.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <Text customClass={styles.benefit_paragraph} text={deceaseSectionTexts.exclusions.link} />
    </div>
  );
};

export default DeceaseSection;
